import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { AppKarte, NummernListe, ReiterWahl } from './AppAnleitung';
import { Fett } from './CodeFelder';
import { VERWALTUNGS_ROLLEN } from '../../lib/rollen';
import {
  appSchritte, handyArt, VERBINDEN_SCHRITTE, ZWEI_FAKTOR_START, DASSELBE_HANDY, GUT_ZU_WISSEN, EINRICHTEN_LINK,
} from '../../lib/zweiFaktor';

const Abschnitt = ({ titel, punkte, testid }) => (
  <section className="space-y-2" data-testid={testid}>
    <h3 className="font-semibold text-slate-900 font-[Manrope]">{titel}</h3>
    <ul className="list-disc space-y-1.5 pl-5 text-sm text-slate-700">
      {punkte.map((p) => <li key={p}><Fett text={p} /></li>)}
    </ul>
  </section>
);

// Knopfleiste bleibt beim Scrollen unten stehen; „Jetzt einrichten“ nur, wenn es noch etwas einzurichten gibt.
const Knopfleiste = ({ onSchliessen }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const einrichtbar = VERWALTUNGS_ROLLEN.includes(user?.role) && user?.zwei_faktor_aktiv === false;
  const einrichten = () => { onSchliessen(); navigate(EINRICHTEN_LINK); };
  return (
    <div className="sticky bottom-0 -mx-6 -mb-6 flex flex-col-reverse gap-2 border-t bg-white px-6 py-4 sm:flex-row sm:justify-end" data-testid="zwei-faktor-anleitung-knoepfe">
      <Button type="button" variant="outline" onClick={onSchliessen} data-testid="zwei-faktor-anleitung-schliessen">Schließen</Button>
      {einrichtbar && (
        <Button type="button" className="bg-blue-800 hover:bg-blue-900" onClick={einrichten} data-testid="zwei-faktor-anleitung-einrichten">Jetzt einrichten</Button>
      )}
    </div>
  );
};

// Anleitung zum Nachlesen (ersetzt die Hilfeartikel), mit Weg in die Einrichtung.
export const AnleitungDialog = ({ open, onOpenChange }) => {
  const art = handyArt(navigator.userAgent, navigator.maxTouchPoints);
  const [reiter, setReiter] = useState(art === 'iphone' ? 'iphone' : 'android');
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-xl" data-testid="zwei-faktor-anleitung-dialog">
        <DialogHeader>
          <DialogTitle className="font-[Manrope]">So richten Sie die Zwei-Faktor-Anmeldung ein</DialogTitle>
          <DialogDescription className="sr-only">Anleitung zur Zwei-Faktor-Anmeldung mit der Google-Authenticator-App</DialogDescription>
        </DialogHeader>
        <div className="space-y-5">
          <div className="space-y-3">
            <ReiterWahl reiter={reiter} onWahl={setReiter} />
            <AppKarte reiter={reiter} art={art} />
            <NummernListe punkte={appSchritte(reiter, art)} testid="zwei-faktor-anleitung-app-schritte" />
          </div>
          <section className="space-y-2">
            <h3 className="font-semibold text-slate-900 font-[Manrope]">Mit der App verbinden</h3>
            <NummernListe punkte={VERBINDEN_SCHRITTE} testid="zwei-faktor-anleitung-verbinden" />
          </section>
          <p className="text-sm text-slate-700">{ZWEI_FAKTOR_START}</p>
          <p className="text-sm text-slate-700">{DASSELBE_HANDY}</p>
          <Abschnitt titel="Neues Handy oder Handy verloren" punkte={[GUT_ZU_WISSEN[2], GUT_ZU_WISSEN[3]]} testid="zwei-faktor-anleitung-neues-handy" />
          <Abschnitt titel="Gut zu wissen" punkte={[GUT_ZU_WISSEN[0], GUT_ZU_WISSEN[1]]} testid="zwei-faktor-anleitung-gut-zu-wissen" />
        </div>
        <Knopfleiste onSchliessen={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
};

export default AnleitungDialog;
